// Pronomen (han/hun) ud fra fornavn — opslag i DST-baseret navneliste (bundlet).

import nameData from '../data/nameGender.da.json';

export type NameGenderCode = 'm' | 'f';
export type DanishPronoun = 'han' | 'hun';

const LOOKUP = nameData.names as Record<string, NameGenderCode>;
const DEFAULT: DanishPronoun =
  nameData.defaultPronoun === 'han' ? 'han' : 'hun';

/** Første fornavn, normaliseret (som DST: første fornavn, små bogstaver). */
export function normalizeFirstName(raw: string): string {
  const first = raw.trim().toLowerCase().split(/\s+/)[0] ?? '';
  if (!first) return '';
  return first.normalize('NFC').replace(/[^a-zæøåé\-]/g, '');
}

/** Kønskode fra navn; null = ukendt eller tvetydigt → brug default. */
export function lookupNameGender(raw: string): NameGenderCode | null {
  const key = normalizeFirstName(raw);
  if (!key) return null;
  return LOOKUP[key] ?? null;
}

export function pronounFromFirstName(raw: string): DanishPronoun {
  const g = lookupNameGender(raw);
  if (g === 'm') return 'han';
  if (g === 'f') return 'hun';
  return DEFAULT;
}

/** {{pron:navn}} — kræver at slot `navn` allerede er udfyldt. */
export function pronounInsertionText(
  forSlotId: string,
  slotValues: Record<string, string>,
): string {
  if (!(forSlotId in slotValues)) return DEFAULT;
  return pronounFromFirstName(slotValues[forSlotId] ?? '');
}

export const nameGenderMeta = {
  source: nameData.source,
  generatedAt: nameData.generatedAt,
  entryCount: nameData.entryCount,
  defaultPronoun: DEFAULT,
};
